const riot = require('riot');

riot.tag2('module-provider-vpoint', '<div class="bg-grad_light_blue w-full h180 pt24"> <div class="text-center ts-hl text-white">特典を受け取る</div> </div> <div class="px24 mtn105"> <div class="w-full p20 rounded-8 elevation-default-mid text-center bg-white mb24"> <div class="f fh mb16"><img class="block s85 object-fit-contain" src="/images/vpoint/logo.svg"></div> <div class="ts-hs text-gray_80 mb4">Vポイント</div> <div class="f fc fb"> <div class="fs40 text-gray_80 mr8">{opts.event.amount.toLocaleString()}</div> <div class="ts-hs text-gray_60">ポイント</div> </div> </div> <div class="mb80" if="{mode === &quot;input_mail&quot;}"> <div class="ts-ps text-gray_80 mb24">特典としてVポイントギフトコードを受け取ることができます。受け取るメールアドレスをご入力ください。</div> <form onsubmit="{toConfirm}"> <input class="input w-full mb24" ref="email" placeholder="メールアドレス" required riot-value="{email}" type="{\'email\'}"> <label class="f fm fit-content cursor-pointer mb26"> <input class="checkbox mr10" type="checkbox" onchange="{onToggleAgree}"> <p class="ts-ps"> <a class="text-link" href="/campaigns/{opts.event.campaign_id}/terms">個人情報の取り扱い</a>に同意しました</p> </label> <button class="button size-l primary w-full mb26" disabled="{!agreeTerms}">確認</button> <p class="text-gray_60 ts-pxs" data-is="atom-anchorify" text="{inputMessage}"></p> </form> </div> <div class="mb40" if="{mode === &quot;confirm_mail&quot;}"> <div class="ts-hs text-gray_80 mb24">メールアドレスのご確認</div> <div class="ts-ps text-gray_80 mb24">こちらのメールアドレスに noreply@incentive.repro.io から<br>Vポイントギフトコードをお送りします。</div> <form onsubmit="{sendMail}"> <input class="input w-full mb24" readonly riot-value="{email}" type="{\'email\'}"> <button class="button size-l primary w-full mb30">メールアドレスを確定</button> </form> <div class="f fh mb30"> <button class="button size-xs text" type="button" onclick="{toInput}">メールアドレスを修正する</button> </div> <p class="text-gray_60 ts-pxs" data-is="atom-anchorify" text="{confirmMessage}"></p> </div> </div>', 'module-provider-vpoint,[data-is="module-provider-vpoint"]{display:block}', 'class="w-full"', function(opts) {
    this.inputMessage = ''
    var confirm_message = `■ Vポイントギフトコードについて
    Vポイントギフトコードを第三者へ譲渡、売買等をすることはできません。
    Vポイントギフトコードに関するサービスの一部または全部は、予告なく中断・停止または終了する場合があります。
    Vポイントギフトコードの盗難、紛失などで第三者がギフトコードを使用してしまった場合でも、CCCMKホールディングス株式会社はその責を負いませんので、保管には十分にご注意ください。
    `;

    this.confirmMessage = confirm_message.replace(/^ +/gm, "");

    this.mode = 'input_mail'

    this.preload = async ({req}) => {
      var email = req.query.email;

      return {
        email,
      };
    };

    this.toConfirm = (e) => {
      e.preventDefault();
      this.email = this.refs.email.value;
      this.mode = 'confirm_mail';
      this.update();
    };

    this.toInput = () => {
      this.email = '';
      this.mode = 'input_mail';
      this.update();
    };

    this.sendMail = async (e) => {
      e.preventDefault();
      var indicator = spat.modal.indicator();
      try {
        await app.api.child('vpoint/publish').post({ onetime_hash: this.opts.onetimeHash, email: this.email });
        spat.router.push(`/receive?hash=${this.opts.onetimeHash}`);
      }
      catch (e) {
        console.error(e);
        spat.modal.open('modal-error', {statusCode: e.status});
      }
      finally {
        indicator.close();
      }
    };

    this.onToggleAgree = (e) => {
      this.agreeTerms = e.currentTarget.checked;
    };
});